<template>
	<div class="extend_box animate__animated animate__fadeIn">
		<div class="extend">
			<div class="search_box">
                <div class="box_line">
                	<div class="title_txts">人社项目编码：</div>
                	<input type="text" class="input_box" placeholder="请输入重庆市人社项目编码" v-model="formData.cqMohrssProjectId" />
                </div>
				<div class="box_line">
					<div class="title_txts">建委项目编码：</div>
					<input type="text" class="input_box" placeholder="请输入重庆市建委项目编码" v-model="formData.projectCode" />
				</div>
				<div class="box_line">
					<div class="title_txts">appKey：</div>
					<input type="text" class="input_box" placeholder="请输入重庆市建委appKey" v-model="formData.appKey" />
				</div>
				<div class="box_line">
					<div class="title_txts">appSecret：</div>
					<input type="text" class="input_box" placeholder="请输入重庆市建委appSecret" v-model="formData.appSecret" />
				</div>
				<div class="box_line">
					<div class="search-btn" v-if="is_admin" style="margin-right: 30px" @click="fnTest" type="primary"><span>一键测试</span></div>
                    <div class="search-btn" @click="fnBind" type="primary"><span>绑定人社平台</span></div>
					<div class="search-btn" @click="fnAddOrEdit" type="primary"><span>保 存</span></div>
				</div>
			</div>
		</div>

		<div class="dialog_choose" v-if="showTest">
			<el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="测试进度" top="20vh" center :visible.sync="showTest" @close="fnTestFinish">
				<div class="line_item">
					<span>等待中: {{ waiting }};</span>
					<span>测试中：{{ testing }};</span>
					<span>测试成功：{{ test_successful }};</span>
					<span>测试失败：{{ test_failure }}。</span>
				</div>
				<div class="cont_list">
					<div class="list_title">
						<div class="title_item">测试名</div>
						<div class="title_item">状态</div>
						<div class="title_item">详情</div>
					</div>
					<div class="list_boxes">
						<div class="list_box">
							<div class="box_line" v-for="(item, index) in testList" :key="index">
								<div class="list_item">{{ item.name }}</div>
								<div class="list_item">
									<span v-if="item.result == 0">等待中</span>
									<span v-else-if="item.result == 1">测试中</span>
									<span v-else-if="item.result == 2">测试成功</span>
									<span v-else style="color: #C03639">测试失败</span>
								</div>
								<p class="list_item" :title="item.details" style="overflow:hidden; white-space:nowrap; justify-content: normal;">{{ item.details }}</p>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer" align="center">
					<div class="btn_line">
						<div class="search-btn" @click="fnTestFinish"><span>确定</span></div>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import request from '@/utils/request';
import { fnRequestPlatform } from '@/utils/upload';
import { getUserInfo } from '@/utils/auth';
export default {
	data() {
		return {
			key_group: {},
			formData: {
				cqMohrssProjectId: '',
				projectCode: '',
				appKey: '',
				appSecret: ''
			},
			showTest: false,
			waiting: 0,
			testing: 0,
			test_successful: 0,
			test_failure: 0,
			testList: [
				{
					name: '上传环境监测实时数据测试',
					url: 'EnvironmentRealTimeTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传环境监测设备定位数据测试',
					url: 'EnvironmentLocationTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传环境监测设备报警数据测试',
					url: 'EnvironmentWarnTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '传环境喷淋（雾炮）打开记录数据测试',
					url: 'EnvironmentSprayOpenTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传塔吊监测基础信息测试',
					url: 'TowerCraneBasicTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传塔吊司机身份识别数据测试',
					url: 'TowerCraneDriverIdentityTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传塔吊监测实时数据测试',
					url: 'TowerCraneRealTimeTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传塔吊监测工作循环数据测试',
					url: 'TowerCraneWorkCycleTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传塔吊监测定位数据测试',
					url: 'TowerCraneLocationTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传塔吊攀爬防护基础信息测试',
					url: 'ClimbingTowerCraneTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传附着式升降脚手架基础信息测试',
					url: 'SmartClimbTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传升降机监测基础信息测试',
					url: 'ElevatorBasicTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传升降机监测实时数据测试',
					url: 'ElevatorRealTimeTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传升降机司机身份识别数据测试',
					url: 'ElevatorDriverIdentityTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传升降机监测工作循环数据测试',
					url: 'ElevatorWorkCycleTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传升降机监测定位数据测试',
					url: 'ElevatorLocationTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传卸料平台监测基础信息测试',
					url: 'UnloadingPlatformBasicTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传卸料平台监测实时数据测试',
					url: 'UnloadingPlatformRealTimeTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传工人现场考勤信息测试',
					url: 'RealNameUploadAttendanceTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '获取工人现场考勤信息的有效性测试',
					url: 'RealNameGetAttendanceUploadResultTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '获取项目信息测试',
					url: 'BasicInfoGetProjectTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '获取项目用工信息测试',
					url: 'RealNameGetProjectWorkerTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传安全帽GPS定位数据测试',
					url: 'SaftyHelmetSafetyHelmetGpsTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传安全帽视频监控数据测试',
					url: 'SafetyHelmetSafetyHelmetWarningTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				},
				{
					name: '上传视频监控数据测试',
					url: 'VideoSurveillanceTest',
					result: 0, //0等待中，1测试中，2测试成功，3测试失败
					details: ''
				}
			],
			testListBackups: [],
			is_admin: false
		};
	},
	created() {
		let userInfo = getUserInfo();
		this.is_admin = userInfo.is_admin ? true : false;
		this.testListBackups = JSON.parse(JSON.stringify(this.testList));
		this.waiting = this.testList.length;
		this.fnGroup();
	},
	methods: {
		fnGroup() {
			request({
				url: 'project/getProjectInfo',
				method: 'GET'
			})
				.then(res => {
					this.key_group = JSON.parse(res.data.key_group);
					for (let _key in this.formData) {
						this.formData[_key] = this.key_group[_key];
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		fnAddOrEdit() {
			for (let _key in this.formData) {
				if (!this.formData[_key]) {
					console.log(_key);
					this.$message.warning('参数不能为空');
					return;
				}

				this.key_group[_key] = this.formData[_key];
			}
			let _data = JSON.stringify(this.key_group) !== '[]' ? JSON.stringify(this.key_group) : JSON.stringify(this.formData);

			request({
				url: 'project/editProject',
				method: 'POST',
				data: {
					key_group: _data
				}
			})
				.then(res => {
					this.$message.success(res.data);
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},

		fnTest() {
			this.$confirm('将对该项目进行接入重庆市建委平台测试，请确认您填写的项目接入码为【测试码】?', '提示', {
				distinguishCancelAndClose: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(() => {
				this.showTest = true;

				for (let _key in this.testList) {
					this.waiting--;
					this.testing++;

					this.testList[_key].result = 1;

					console.log(this.testList[_key]);

					fnRequestPlatform(
						{
							url: '/Cq/' + this.testList[_key].url,
							method: 'GET'
						},
						res => {
							this.testing--;
							if (res.code === 1) {
								this.testList[_key].result = 2;
								this.test_successful++;
							} else {
								this.testList[_key].details = res.data;
								this.testList[_key].result = 3;
								this.test_failure++;
							}
						}
					);
				}
			});
		},

		fnTestFinish() {
			this.showTest = false;
			this.testList = JSON.parse(JSON.stringify(this.testListBackups));
			this.waiting = this.testList.length;
			this.testing = 0;
			this.test_successful = 0;
			this.test_failure = 0;
		},
        fnBind(){
            fnRequestPlatform(
              {
                url: '/CqMohrss/bind_project',
                method: 'GET'
              },
              res => {
                if (res.code == 1) {
                  this.$message.success(res.data);
                } else {
                  this.$message.warning(res.data);
                }
              }
            );
        }
	}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.extend_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.extend {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	height: 148px;
	width: 1880px;
	margin-top: 100px;
	margin-left: 20px;
	.box_line {
		width: 1880px;
		height: 72px;
		margin-bottom: 10px;
		@include flex-box(center, center);
		.title_txts {
			width: 170px;
			color: #fff;
			font-size: 18px;
		}
		.input_box {
			width: 311px;
			height: 40px;
			line-height: 30px;
			padding-left: 15px;
			color: rgba(77, 180, 244, 0.7);
			font-size: 12px;
			border-radius: 5px;
			outline: none;
			background-color: rgba(77, 180, 244, 0.2);
			border: none;
			&::-webkit-input-placeholder {
				color: rgba(77, 180, 244, 0.7);
			}
			&::-moz-placeholder {
				/* Mozilla Firefox 19+ */
				color: rgba(77, 180, 244, 0.7);
			}
			&:-moz-placeholder {
				/* Mozilla Firefox 4 to 18 */
				color: rgba(77, 180, 244, 0.7);
			}
			&:-ms-input-placeholder {
				/* Internet Explorer 10-11 */
				color: rgba(77, 180, 244, 0.7);
			}
		}
	}
}

.dialog_choose {
	.line_item {
		margin: 5px;
		height: 20px;
		line-height: 20px;
		color: rgba(255, 255, 255, 0.8);
	}
	.btn_line {
		@include flex-box(center, center);
	}
	/deep/ .el-dialog {
        width: 910px;
        height: 630px;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
		.row-item {
			color: white;
		}
	}
	/deep/ .el-form-item__label {
		color: #4db4f4;
	}
	/deep/ .el-dialog__title {
		color: #4db4f4;
	}
	/deep/ .el-dialog__close {
		color: #4db4f4;
	}
    /deep/ .el-dialog {
        width: 910px;
        height: 630px;
    }
	.cont_list {
		width: 860px;
		height: 425px;
		color: #ffffff;
		font-size: 16px;
		border-radius: 10px;
		margin: 0;
		background-color: rgba(29, 68, 149, 0.1);
		.list_title {
			width: 860px;
			height: 48px;
			background: url(../../../assets/img/per_list_bg.png) no-repeat;
			background-size: 100% 100%;
			@include flex-box(flex-start, center);
			.title_item {
				height: 48px;
				@include flex-box(center, center);
				&:nth-child(1) {
					width: 300px;
					margin-right: 2px;
					margin-left: 30px;
				}
				&:nth-child(2) {
					width: 190px;
					margin: 0 2px;
				}
				&:nth-child(3) {
					width: 310px;
					margin: 0 2px;
				}
				.select {
					width: 20px;
					height: 20px;
					border: 1px solid #65a6dd;
					border-radius: 2px;
					cursor: pointer;
					@include prefixCss3(transition, border-color 0.2s);
					&:hover {
						border-color: #409eff;
					}
					&.active {
						background-color: #409eff;
						border-color: #409eff;
						&::after {
							content: '';
							display: block;
							width: 100%;
							height: 100%;
							@include set-bg-img('../../../assets/images/icon-yes.png');
						}
					}
				}
			}
		}
		.list_boxes {
			width: 800px;
			height: 375px;
			margin-left: 30px;
			position: relative;
			overflow: hidden;
			.list_box {
				position: absolute;
				left: 0;
				right: -25px;
				top: 0;
				bottom: 0;
				overflow-x: hidden;
				overflow-y: auto;
				.box_line {
					width: 800px;
					height: 70px;
					margin: 5px 0 0 0px;
					border-bottom: 1px dashed #1d4495;
					@include flex-box(flex-start, center);
					&:hover {
						background-color: rgba(49, 88, 128, 0.4);
					}
					.list_item {
						height: 70px;
						text-align: center;
						@include flex-box(center, center);
						&:nth-child(1) {
							width: 300px;
							margin-right: 2px;
						}
						&:nth-child(2) {
							width: 200px;
							margin: 0 2px;
						}
						&:nth-child(3) {
							width: 300px;
							margin: 0 2px;
						}
						.select {
							width: 20px;
							height: 20px;
							border: 1px solid #65a6dd;
							border-radius: 2px;
							cursor: pointer;
							@include prefixCss3(transition, border-color 0.2s);
							&:hover {
								border-color: #409eff;
							}
							&.active {
								background-color: #409eff;
								border-color: #409eff;
								&::after {
									content: '';
									display: block;
									width: 100%;
									height: 100%;
									@include set-bg-img('../../../assets/images/icon-yes.png');
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/ProjectKey/ProjectKeyCqmohrssCq3/index.vue